import { render } from "./OrderSingle.vue?vue&type=template&id=73b72660&scoped=true"
import script from "./OrderSingle.vue?vue&type=script&lang=js"
export * from "./OrderSingle.vue?vue&type=script&lang=js"

import "./OrderSingle.vue?vue&type=style&index=0&id=73b72660&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b72660"]])

export default __exports__